import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";

interface FiltersState {
  filters?: Record<string, string>;
  search?: string;
}

interface FiltersActions {
  setFilters: (filters: Record<string, string>) => void;
  setSearch: (search: string) => void;
  resetFilters: () => void;
}

export const initialState: FiltersState = {
  filters: undefined,
  search: undefined,
};

export const useFiltersStore = createWithEqualityFn<FiltersState & FiltersActions>()(
  (set) => ({
    setFilters: (filters: Record<string, string>) => {
      set({ filters });
    },
    setSearch: (search: string) => set({ search }),
    resetFilters: () => set({ ...initialState }),
  }),
  shallow
);
